/**
 * Checks if the current browser/device likely supports emojis,
 * Returns true for iOS, Android, Windows 11, and macOS.
 * Returns false for Linux, older Windows, or server-side environments.
 */
export function supportsEmojis(): boolean {
  if (typeof window === "undefined") return false;

  const ua = navigator.userAgent;

  // iOS & Android → reliable
  if (/iPhone|iPad|Android/i.test(ua)) return true;

  // Windows 11 → reliable
  if (/Windows NT 10.0; Win64; x64/i.test(ua)) return true;

  // macOS → reliable
  if (/Macintosh/i.test(ua)) return true;

  // Linux & older Windows → unreliable
  return false;
}
